import { createFileRoute } from '@tanstack/react-router';
import { ComparisonPage } from '@/features/travel-credit-card/comparison/comparison-page';
import { COMPARISON_SEO } from '@/features/travel-credit-card/content/comparison-content';
import {
	ForceLightScheme,
	forceLightSchemeScript,
} from '@/features/travel-credit-card/layout/force-light-scheme';
import { seo } from '@/utils/seo';

export const Route = createFileRoute('/travel-credit-card_/comparison')({
	head: () => ({
		meta: [
			...seo({
				title: COMPARISON_SEO.title,
				description: COMPARISON_SEO.description,
			}),
			// Override the root route's `noindex,nofollow` — this is a public,
			// crawlable SEO content page.
			{ name: 'robots', content: 'index, follow' },
		],
		links: [{ rel: 'canonical', href: COMPARISON_SEO.canonicalUrl }],
		// Pin color-scheme: light for this route (see force-light-scheme.tsx).
		scripts: [{ children: forceLightSchemeScript }],
	}),
	component: ComparisonRoute,
	// Static long-form content — SSR for SEO (app default is SPA).
	ssr: true,
});

function ComparisonRoute() {
	return (
		<>
			<ForceLightScheme />
			<ComparisonPage />
		</>
	);
}
